import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { MediaAttachment, MediaType } from '../models/MediaAttachment';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class MediaService {
  constructor(
    private _http: HttpClient,
  ) {}

  private debugLog(area: string, message: string, data: any = null) {
    const debugMessage = `[SignalR ${area}] ${message}`;
    console.log(debugMessage, data || '');
  }

  uploadFile(file: File, accessToken: string, mediaType: MediaType): Observable<{ progress: number; result?: MediaAttachment }> {
    const formData = new FormData();
    formData.append('file', file);

    return new Observable((observer) => {
      this._http
        .post<Array<{ originalFileName: string; filePath: string; fileSize: string }>>(
          `${environment.apiUrl}/chat/media`,
          formData,
          {
            headers: { RoarChatAuth: accessToken },
            reportProgress: true,
            observe: 'events',
          }
        )
        .subscribe({
          next: (event: HttpEvent<any>) => {
            if (event.type === HttpEventType.Sent) {
              observer.next({ progress: 0 });
            } else if (event.type === HttpEventType.UploadProgress) {
              const progress = event.total
                ? Math.round((100 * event.loaded) / event.total)
                : -1;
              observer.next({ progress });
            } else if (event.type === HttpEventType.Response) {
              const result = event.body?.[0];
              const uploadResult: MediaAttachment = {
                path: result?.filePath || '',
                mediaType,
                fileName: result?.originalFileName || '',
              };
              observer.next({ progress: 100, result: uploadResult });
              observer.complete();
            }
          },
          error: (err) => observer.error(err),
        });
    });
  }
}